<template>
  <!-- 组织架构 -->
  <div>
    <div class="box">
      <!-- 左边 -->
      <div class="boxleft glo_Table">
        <el-table
          :data="menuTableData"
          style="width: 100%"
          row-key="deptId"
          border
          :height="leftHeight"
          default-expand-all
          :tree-props="{
            children: 'childDeptList',
            hasChildren: 'hasChildren',
          }"
        >
          <el-table-column
            prop="departmentName"
            label="部门"
            sortable
            width="160"
          >
          </el-table-column>
          <el-table-column fixed="right" label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="small">
                <span
                  v-if="hasPermiss('admin:dept:addDept')"
                  class="tablebut"
                  @click="menuadd(scope.row)"
                  >新增</span
                >

                <span
                  v-if="hasPermiss('admin:dept:udpateDept')"
                  class="tablebut"
                  @click="menumodify(scope.row.deptId)"
                  >编辑</span
                >
                <span
                  v-if="hasPermiss('admin:dept:delDept')"
                  class="tablebut"
                  @click="delBtns(scope.row)"
                  >删除</span
                >

                <span
                  v-if="
                    scope.row.isDisable == 0 &&
                      hasPermiss('admin:dept:stopDept')
                  "
                  class="tablebut"
                  @click="stopDept(scope.row)"
                  >禁用</span
                >
                <span
                  v-if="
                    scope.row.isDisable == 1 &&
                      hasPermiss('admin:dept:startDept')
                  "
                  class="tablebut"
                  style="color: #999"
                  @click="startDept(scope.row)"
                  >启用</span
                >
                <span
                  v-if="
                    scope.row.isDefault != 1 &&
                    hasPermiss('admin:dept:setDefaultDept')
                  "
                  class="tablebut"
                  @click="setDefaultDept(scope.row)"
                  >设为默认</span
                >
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 右边 -->
      <div class="boxright">
        <!-- 按钮列表 -->
        <div class="glo_btnList" ref="btnList">
          <div class="glo_btnList_left">
            <el-button
              v-if="hasPermiss('admin:dept:addDept')"
              class="glo_btnItems glo_bgcMainColor"
              @click="menuadd()"
              >新增部门
            </el-button>
            <el-button
              class="glo_btnItems"
              v-if="hasPermiss('admin:dept:startDept')"
              @click="startDeptMore()"
              >批量启用
            </el-button>
            <el-button
              v-if="hasPermiss('admin:dept:stopDept')"
              class="glo_btnItems"
              @click="stopDeptMore()"
              >批量禁用
            </el-button>
            <el-button class="glo_btnItems" @click="DaochuMore">导出</el-button>
          </div>

          <queryBtns
            :MoreConditions="MoreConditions"
            :showMoreBtns="false"
            @clerBtns="clerBtns"
            @queryBtn_ok="queryBtn_ok"
            @moreParam="moreParam"
          ></queryBtns>
        </div>
        <!-- 查询条件 -->
        <div ref="queryForm">
          <el-form
            :model="queryData"
            :class="isHaseMore ? 'glo_form hasMoreParam' : 'glo_form'"
            label-position="left"
          >
            <el-form-item class="queryItems" label="部门名称:">
              <el-input
                clearable
                placeholder="请输入"
                v-model="queryData.deptName"
                @keyup.native.enter="queryBtn_ok"
              ></el-input>
            </el-form-item>
            <el-form-item class="queryItems" label="上级部门:">
              <el-select
                filterable
                clearable
                v-model="queryData.parentName"
                placeholder="请输入"
                @change="queryBtn_ok"
              >
                <el-option
                  v-for="(item, index) in allDepLists"
                  :key="index"
                  :label="item.departmentName"
                  :value="item.departmentName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>

        <!-- 表格 -->
        <div class="glo_Table" ref="tableWrapper">
          <el-table
            :height="tableHeigth"
            ref="mytable"
            @row-click="rowclick"
            :data="tableData"
            stripe
            border
            @selection-change="handleSelectionChange"
          >
            <el-table-column fixed="left" label="序号" type="index" width="60">
            </el-table-column>
            <el-table-column fixed="left" type="selection" width="60">
            </el-table-column>
            <template v-for="(item, index) in myTableHeard">
              <el-table-column
                :key="index"
                :label="item.name"
                :prop="item.field"
                sortable
                :min-width="item.width"
                :data-isTotal="item.isTotal"
                v-if="item.field == 'isDisableShow'"
              >
                <template slot-scope="scope">
                  <div style="color: #f00" v-if="scope.row.isDisable == '1'">
                    禁用
                  </div>
                  <div v-else>启用</div>
                </template>
              </el-table-column>
              <el-table-column
                :key="index"
                :label="item.name"
                :prop="item.field"
                sortable
                :min-width="item.width"
                :data-isTotal="item.isTotal"
                v-else-if="item && item.isShow"
                show-overflow-tooltip
              >
              </el-table-column>
            </template>
            <el-table-column fixed="right" label="操作" :width="operationWidth">
              <template slot-scope="scope">
                <div class="tabRightBtns">
                  <el-button
                    v-if="hasPermiss('admin:dept:udpateDept')"
                    class="rbtns"
                    @click.stop="menumodify(scope.row.deptId)"
                    >编辑</el-button
                  >
                  <el-button
                    v-if="
                      scope.row.isDisable == '0' &&
                        hasPermiss('admin:dept:stopDept')
                    "
                    class="rbtns"
                    @click.stop="stopDept(scope.row)"
                    >禁用</el-button
                  >
                  <el-button
                    v-if="
                      scope.row.isDisable == '1' &&
                        hasPermiss('admin:dept:startDept')
                    "
                    class="rbtns"
                    @click.stop="startDept(scope.row)"
                    >启用</el-button
                  >
                  <el-button
                    v-if="hasPermiss('admin:dept:delDept')"
                    class="rbtns"
                    @click.stop="delBtns(scope.row)"
                    >删除</el-button
                  >
                  <el-button
                    v-if="
                      scope.row.isDefault != 1 &&
                        hasPermiss('admin:dept:setDefaultDept')
                    "
                    class="rbtns"
                    @click.stop="setDefaultDept(scope.row)"
                    >设为默认</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 分页组件 -->
        <paging
          ref="pags"
          :pageNum="pageNum"
          :total="total"
          :sizeList="sizeList"
          :size="size"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
        ></paging>
      </div>
    </div>

    <!-- 弹窗 部门新建修改 -->
    <myDialog
      :diaWidth="diaWidth"
      :dialogTitle="PopUpTitle"
      :isShowDialog="menushowBOX"
      @handleCloseDia="handleCloseDia"
      @diaCancelBtn="diaCancelBtn"
      @diaConfirmBtn="diaConfirmBtn('CalculationRulesRef')"
    >
      <div class="glo_dialogForm">
        <el-form
          class="diaForm"
          v-if="menushowBOX"
          ref="CalculationRulesRef"
          :model="CalculationRules"
          label-width="100px"
          :rules="rules"
        >
          <el-form-item
            class="dialogFormItems"
            prop="departmentName"
            label="部门名称:"
          >
            <el-input
              placeholder="请输入"
              clearable
              v-model="CalculationRules.departmentName"
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="departmentNumber"
            label="部门编号:"
          >
            <el-input
              placeholder="请输入"
              clearable
              v-model="CalculationRules.departmentNumber"
            ></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="isDisable" label="状态:">
            <el-select
              v-model="CalculationRules.isDisable"
              clearable
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="item in isDisableLists"
                :key="item.statusVal"
                :label="item.showName"
                :value="item.statusVal + ''"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            class="dialogFormItems"
            prop="organizationDepartmentTypeId"
            label="部门类型:"
          >
            <el-select
              v-model="CalculationRules.organizationDepartmentTypeId"
              clearable
              filterable
              placeholder="请选择"
              :disabled="dialogType == 'edit'"
            >
              <el-option
                v-for="item in bumenTypeList"
                :key="item.typeId"
                :label="item.typeName"
                :value="item.typeId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="parentId"
            label="上级部门:"
          >
            <el-select
              v-model="CalculationRules.parentId"
              clearable
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="item in allDepLists"
                :key="item.deptId"
                :label="item.departmentName"
                :value="item.deptId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="chargePersonName"
            label="负责人:"
          >
            <el-input
              placeholder="请输入"
              v-model="CalculationRules.chargePersonName"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            label="部门地址:"
            style="width: 100%"
          >
            <div class="addressDiv">
              <el-select
                v-model="CalculationRules.provinceName"
                clearable
                placeholder="请输入省"
                filterable
                remote
                :loading="false"
                :remote-method="getProvinceNameList"
                @change="changeProvince"
              >
                <el-option
                  v-for="(item, index) in provinceNameList"
                  :key="index"
                  :label="item.districtName"
                  :value="item.districtName"
                ></el-option>
              </el-select>
              <el-select
                v-model="CalculationRules.cityName"
                clearable
                placeholder="请输入城市"
                filterable
                remote
                :loading="false"
                :remote-method="getCityNameList"
                :disabled="!CalculationRules.provinceName"
                @change="changeCity"
              >
                <el-option
                  v-for="(item, index) in cityNameList"
                  :key="index"
                  :label="item.districtName"
                  :value="item.districtName"
                ></el-option>
              </el-select>
              <el-select
                v-model="CalculationRules.areaName"
                clearable
                placeholder="请输入区/镇"
                filterable
                remote
                :loading="false"
                :remote-method="getAreaNameList"
              >
                <el-option
                  v-for="(item, index) in areaNameList"
                  :key="index"
                  :label="item.districtName"
                  :value="item.districtName"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item
            style="width: 100%"
            class="dialogFormItems"
            prop="address"
            label="详细地址:"
          >
            <el-input
              placeholder="请输入部门详细地址"
              v-model="CalculationRules.address"
              clearable
            ></el-input>
          </el-form-item>

          <el-form-item class="dialogFormItems" prop="phone" label="联系电话:">
            <el-input
              placeholder="请输入"
              v-model="CalculationRules.phone"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="takeGoodsTel"
            label="提货电话:"
          >
            <el-input
              placeholder="请输入"
              v-model="CalculationRules.takeGoodsTel"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="sort" label="排序:">
            <el-input
              placeholder="请输入"
              v-model="CalculationRules.sort"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item class="dislogFormTextarea" prop="comment" label="备注:">
            <el-input
              type="textarea"
              rows="2"
              v-model="CalculationRules.comment"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>
    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
      <!-- 当前页面的查询条件 -->
      <div ref="queryForm">
        <el-form
          :model="queryData"
          class="glo_form hasMoreParam"
          label-position="left"
        >
          <el-form-item class="queryItems" label="上级地区:">
            <el-select
              v-model="queryData.parentName"
              clearable
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="remoteMethod"
              :loading="false"
              @change="changeParentAddress"
            >
              <el-option
                v-for="(item, index) in SuperiorRegionList"
                :key="index"
                :label="item.districtName"
                :value="item.districtName"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item class="queryItems" label="地区名称:">
            <el-input
              clearable
              v-model="queryData.districtName"
              placeholder="请输入"
              @keyup.enter.native="queryBtn_ok"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </exportCompoent>
  </div>
</template>

<script>
import paging from "@/components/pagings.vue";
import queryBtns from "@/components/queryBtns.vue";
import myDialog from "@/components/Dialog.vue";
import exportjs from "@/assets/js/Mixins/export.js"; //导出的公共js
export default {
  mixins: [exportjs],
  inject: ["reload"],
  components: {
    paging,
    queryBtns,
    myDialog,
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "组织架构", //导出时默认文件名
        apiName: "/admin/v3/tms/dept/getDeptList", //导出的数据列表接口名(动态列表都是这个)
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "GET", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      bumenTypeList: [], //部门类型
      CalculationRules: {
        departmentName: "", //名称
        departmentNumber: "", //编号
        isDisable: "0", //是否禁用0=否1=是
        parentId: "", //上级部门value
        takeGoodsTel: "", //提货电话
        sort: "1", //菜单排序
        comment: "", //
        organizationDepartmentTypeId: "", //部门类型
        address: "", //详细地址
        areaName: "", //区
        chargePersonName: "", //负责人
        cityName: "", //城市
        phone: "", //联系电话
        provinceName: "", //省
      },
      rules: {
        departmentName: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        departmentNumber: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        isDisable: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        organizationDepartmentTypeId: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },
      PopUpTitle: "", //弹窗标题
      menushowBOX: false, //菜单弹窗
      dialogType: "add",
      allDepLists: [], //所有部门(不分层级)
      menuTableData: [], //左边菜单
      diaWidth: "40%",
      //\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\

      queryData: {
        deptName: "",
        parentName: "",
      },

      // ================
      pageNum: 1, //页码
      total: 0, //总条数
      sizeList: [10, 20, 50, 100, 200],
      size: this.$COMMON.pageTotals, //一页几条
      nextPage: false, //是否有下一页
      show_sortTableHeard: false, //显示弹窗
      show_upload: false, //显示上传弹窗
      originalTabelHeadeTitle: [],
      selectLength: 0, //显示的长度
      allCheck: false, //全选
      leftHeight: "75vh",
      tableHeigth: "75vh",
      myTableHeard: [], //我的表头
      tabelHeadeTitle: [
        {
          name: "部门编号",
          field: "departmentNumber",
          sort: 1,
          isShow: true,
          isTotal: false,
          width: "110",
        },
        {
          name: "部门名称",
          field: "departmentName",
          sort: 1,
          isShow: true,
          isTotal: false,
          width: "110",
        },
        {
          name: "部门类型",
          field: "organizationDepartmentTypeName",
          sort: 1,
          isShow: true,
          isTotal: false,
          width: "110",
        },
        {
          name: "上级部门",
          field: "parentName",
          sort: 1,
          isShow: true,
          isTotal: false,
          width: "110",
        },
        {
          name: "所在省份",
          field: "provinceName",
          sort: 1,
          isShow: true,
          isTotal: false,
          width: "110",
        },
        {
          name: "所在城市",
          field: "cityName",
          sort: 1,
          isShow: true,
          isTotal: false,
          width: "110",
        },
        {
          name: "地址",
          field: "address",
          sort: 1,
          isShow: true,
          isTotal: false,
          width: "110",
        },

        {
          name: "负责人",
          field: "chargePersonName",
          sort: 1,
          isShow: true,
          isTotal: false,
          width: "108",
        },
        {
          name: "联系电话",
          field: "phone",
          sort: 1,
          isShow: true,
          isTotal: false,
          width: "130",
        },
        {
          name: "提货电话",
          field: "takeGoodsTel",
          sort: 1,
          isShow: true,
          isTotal: false,
          width: "130",
        },
        {
          name: "是否禁用",
          field: "isDisableShow",
          sort: 1,
          isShow: true,
          isTotal: false,
          width: "110",
        },
        {
          name: "排序",
          field: "sort",
          sort: 1,
          isShow: true,
          isTotal: false,
          width: "80",
        },
        {
          name: "备注",
          field: "comment",
          sort: 1,
          isShow: true,
          isTotal: false,
          width: "160",
        },
        {
          name: "新建时间",
          field: "createTime",
          sort: 1,
          isShow: true,
          isTotal: false,
          width: "160",
        },
        {
          name: "申请人",
          field: "applicantUserName",
          sort: 1,
          isShow: true,
          isTotal: false,
          width: "100",
        },
        {
          name: "修改时间",
          field: "updateTime",
          sort: 1,
          isShow: true,
          isTotal: false,
          width: "160",
        },
        {
          name: "修改人",
          field: "updateUserName",
          sort: 1,
          isShow: true,
          isTotal: false,
          width: "100",
        },
      ],
      tableData: [1, 2, 3],
      totalArr: [], //需要合计的字段
      className: "", //导出需要
      fieldName: [], //下载字段名
      head: [], //下载表头字段
      fileList: [],
      sortName: "组织架构", //排序名
      pageGroupName: "organizationalStructure", //页面标识
      selectTableData: [], //选中的数据

      deperIds: [],
      MoreConditions: "更多条件", //  输入框绑定动态class
      isHaseMore: false, //false == 更多条件  true ==收起条件

      isDisableLists: [
        {
          showName: "禁用",
          statusVal: "1",
        },
        {
          showName: "启用",
          statusVal: "0",
        },
      ],

      provinceNameList: [],
      cityNameList: [],
      areaNameList: [],
      SuperiorRegionList:[]
    };
  },
  computed:{
    operationWidth(){
      let width = 240
      const piece = 60
      if(!this.hasPermiss('admin:dept:udpateDept')){
        width-=piece
      }
      if(!this.hasPermiss('admin:dept:stopDept') && !this.hasPermiss('admin:dept:startDept')){
        width-=piece
      }
      if(!this.hasPermiss('admin:dept:delDept')){
        width-=piece
      }
      if(!this.hasPermiss('admin:dept:setDefaultDept')){
        width-=piece
      }
      return width
    }
  },
  updated() {},
  created() {
    this.myTableHeard = this.tabelHeadeTitle;

    this.endtime = this.$TOOLS.getCurrentDate(); //今天的时间;
    this.sarttime = this.$TOOLS.getFlexDate(-3); //三天前
    this.times = [this.sarttime, this.endtime];
    this.getDepListALl();
    this.getData();
    this.departmentHierarchy(); //左边表格数据
  },
  mounted() {
    const that = this;
  },
  activated() {
    // this.$nextTick(() => {
    //   this.fetTableHeight();
    // });
  },
  watch: {},
  methods: {
    remoteMethod(){},
    changeParentAddress(){},
    DaochuMore() {
      this.isShowDialog_dc = true;
    },
    //省的值变化
    changeProvince(e) {
      this.CalculationRules.cityName = "";
      this.CalculationRules.areaName = "";
      this.getCityNameList("", e);
    },
    //市的值变化
    changeCity(e) {
      this.CalculationRules.areaName = "";
      this.getAreaNameList("", e);
    },
    // 获取省远程搜索
    getProvinceNameList(e) {
      let pN = "中华人民共和国";
      // if (!e) {
      //   // 默认
      //   pN = "中华人民共和国";
      // }
      let p = {
        pageStart: 1,
        pageTotal: 100,
        districtName: e,
        parentName: pN,
      };
      this.$API.wtl_getDistrictList(p).then((res) => {
        this.provinceNameList = res.data.result.data || [];
      });
    },
    // 获取城市远程搜索
    getCityNameList(e, pName) {
      let pN = pName;
      let p = {
        pageStart: 1,
        pageTotal: 100,
        districtName: e,
        parentName: pN,
      };
      this.$API.wtl_getDistrictList(p).then((res) => {
        this.cityNameList = res.data.result.data || [];
      });
    },
    // 获取区远程搜索
    getAreaNameList(e, pName) {
      let pN = pName;
      let p = {
        pageStart: 1,
        pageTotal: 100,
        districtName: e,
        parentName: pN,
      };
      this.$API.wtl_getDistrictList(p).then((res) => {
        this.areaNameList = res.data.result.data || [];
      });
    },
    // 点击选中当前行
    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row);
    },
    clerBtns() {
      //  重置按钮
      this.queryData = {
        deptName: "",
        parentName: "",
      };
    },

    moreParam() {
      this.isHaseMore = !this.isHaseMore;
      if (this.isHaseMore) {
        this.MoreConditions = "收起条件";
      } else {
        this.MoreConditions = "更多条件";
      }

      this.$nextTick(() => {
        this.fetTableHeight();
      });
    },

    // 单个禁用部门
    stopDept(data) {
      let ids = [data.deptId];
      this.$confirm("是否禁用部门: " + data.departmentName, "提示:")
        .then(() => {
          let param = {
            deptIds: ids,
          };
          this.$API.wtl_stopDept(param).then((res) => {
            if (res.data.status == "success") {
              this.$message.success(res.data.message || "操作成功");
              this.departmentHierarchy();
              this.getData();
            }
          });
        })
        .catch(() => {});
    },
    // 批量禁用
    stopDeptMore() {
      if (this.selectTableData.length < 1) {
        this.$message.warning("请选择需要禁用的部门");
        return false;
      }

      let ids = [];
      this.selectTableData.forEach((item) => {
        ids.push(item.deptId);
      });
      this.$confirm("确定要禁用所选部门吗?")
        .then(() => {
          let param = {
            deptIds: ids,
          };
          this.$API.wtl_stopDept(param).then((res) => {
            if (res.data.status == "success") {
              this.$message.success(res.data.message || "操作成功");
              this.departmentHierarchy();
              this.getData();
            }
          });
        })
        .catch(() => {});
    },
    // 批量启用
    startDeptMore() {
      if (this.selectTableData.length < 1) {
        this.$message.warning("请选择需要启用的部门");
        return false;
      }

      let ids = [];
      this.selectTableData.forEach((item) => {
        ids.push(item.deptId);
      });
      this.$confirm("确定要启用所选部门吗?")
        .then(() => {
          let param = {
            deptIds: ids,
          };
          this.$API.wtl_startDept(param).then((res) => {
            if (res.data.status == "success") {
              this.$message.success(res.data.message || "操作成功");
              this.departmentHierarchy();
              this.getData();
            }
          });
        })
        .catch(() => {});
    },
    // 启用部门
    startDept(data) {
      let ids = [data.deptId];
      this.$confirm("是否启用部门: " + data.departmentName, "提示:")
        .then(() => {
          let param = {
            deptIds: ids,
          };
          this.$API.wtl_startDept(param).then((res) => {
            if (res.data.status == "success") {
              this.$message.success(res.data.message || "操作成功");
              this.departmentHierarchy();
              this.getData();
            }
          });
        })
        .catch(() => {});
    },
    // 设置默认部门
    setDefaultDept(data) {
      this.$confirm(`是否设置${data.departmentName}为默认部门` , "提示:")
        .then(() => {
          let param = {
            deptId: data.deptId,
          };
          this.$API.setDefaultDept(param).then((res) => {
            if (res.data.status == "success") {
              this.$message.success(res.data.message || "操作成功");
              this.departmentHierarchy();
              this.getData();
            }
          });
        })
        .catch(() => {});
    },
    // 递归获取部门下所有id
    getDpIds(data) {
      let ids = this.deperIds || [];
      ids.push(data.departmentId);
      let arrs = data.childDeptList || [];
      for (var i = 0; i < arrs.length; i++) {
        ids.push(arrs[i].departmentId);
        let arr2 = arrs[i].childDeptList || [];
        for (var j = 0; j < arr2.length; j++) {
          this.getDpIds(arr2[j]);
        }
      }
      this.deperIds = ids;
      return this.deperIds;
    },
    // 获取所有部门
    getDepListALl() {
      let param = {
        pageStart: 1,
        pageTotal: 200,
      };
      this.$API.wtl_getDeptList(param).then((res) => {
        this.allDepLists = res.data.result.data || [];
        this.fetTableHeight();
      });
    },

    // 获取数据
    getData() {
      let param = {
        deptName: this.queryData.deptName,
        parentName: this.queryData.parentName,
        pageStart: this.pageNum,
        pageTotal: this.size,
      };
      this.$API.wtl_getDeptList(param).then((res) => {
        this.className = res.data.result.className || "";
        this.tableData = res.data.result.data || [];
        this.total = res.data.result.pageCount || 0;
        this.fetTableHeight();
      });
    },

    // 部门层级列表
    departmentHierarchy() {
      this.$API.wtl_getLeftDeptList().then((res) => {
        let bmList = res.data.result || [];
        let objs = {
          departmentName: "无上级",
          deptId: "-1",
        };
        let allbm = JSON.parse(JSON.stringify(bmList));
        allbm.unshift(objs);
        // this.allDepLists = allbm;

        this.menuTableData = bmList;
        // this.menuTableData = this.diGuiGetMeun(bmList, "-1");
      });
    },
    //递归获取数据
    diGuiGetMeun(data, parentId) {
      let tree = [];
      let temp;
      data.forEach((item) => {
        if (item.parentId == parentId) {
          let obj = item;
          obj.departmentName = item.departmentName;
          obj.childDeptList = [];
          temp = this.diGuiGetMeun(data, item.departmentId);
          if (temp.length > 0) {
            obj.childDeptList = temp;
          }
          tree.push(obj);
        }
      });
      //排序
      for (var i = 0; i < tree.length - 1; i++) {
        for (var j = 0; j < tree.length - 1 - i; j++) {
          if (tree[j].sort > tree[j + 1].sort) {
            let temp = tree[j + 1];
            tree[j + 1] = tree[j];
            tree[j] = temp;
          }
        }
      }
      return tree;
    },
    //新建
    menuadd(row) {
      console.log(row);
      this.getDepListALl();
      if (row) {
        this.CalculationRules.parentId = row.deptId;
      }
      this.getDepTypeDownList();
      this.getProvinceNameList();
      this.PopUpTitle = "新建部门";
      this.menushowBOX = true;
      this.dialogType = "add";
    },

    // 部门类型下拉列表
    getDepTypeDownList() {
      this.$API.wtl_getDeptTypeDownList().then((res) => {
        let datas = res.data.result || [];
        this.bumenTypeList = datas;
      });
    },

    //菜单修改
    menumodify(id, num) {
      this.getDepTypeDownList();
      // 获取详情
      this.$API.wtl_getDeptDetail({ deptId: id }).then((res) => {
        this.PopUpTitle = "修改部门";
        this.menushowBOX = true;
        this.dialogType = "edit";
        // this.CalculationRules = res.data.result;
        let datas = res.data.result;

        this.getProvinceNameList();
        this.getCityNameList("", datas.provinceName);
        this.getAreaNameList("", datas.cityName);

        this.CalculationRules.parentId = datas.parentId;
        this.CalculationRules.departmentNumber = datas.departmentNumber;
        this.CalculationRules.departmentName = datas.departmentName;
        this.CalculationRules.isDisable = datas.isDisable + "";
        this.CalculationRules.sort = datas.sort;
        this.CalculationRules.address = datas.address;
        this.CalculationRules.provinceName = datas.provinceName;
        this.CalculationRules.takeGoodsTel = datas.takeGoodsTel;
        this.CalculationRules.parentName = datas.parentName;
        this.CalculationRules.organizationDepartmentTypeName =
          datas.organizationDepartmentTypeName;
        this.CalculationRules.organizationDepartmentTypeId =
          datas.organizationDepartmentTypeId + "";
        this.CalculationRules.chargePersonName = datas.chargePersonName;
        this.CalculationRules.cityName = datas.cityName;
        this.CalculationRules.phone = datas.phone;
        this.CalculationRules.comment = datas.comment;
        this.CalculationRules.deptId = datas.deptId;
        this.CalculationRules.areaName = datas.areaName || "";
      });
    },
    // 删除
    delBtns(data) {
      console.log(data);
      this.$confirm("是否删除部门: " + data.departmentName + "?", "提示:")
        .then(() => {
          let param = {
            deptIds: [data.deptId],
          };
          this.$API.wtl_delDept(param).then((res) => {
            if (res.data.status == "success") {
              this.$message.success(res.data.message || "操作成功");
              this.departmentHierarchy();
              this.getData();
            }
          });
        })
        .catch(() => {});
    },

    /***
     * ====== 弹窗组件方法 ======
     */
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.menushowBOX = false;
      this.CalculationRules = {
        departmentName: "", //名称
        departmentNumber: "", //编号
        isDisable: "0", //是否禁用0=否1=是
        parentId: "", //上级部门value
        takeGoodsTel: "", //提货电话
        sort: "1", //菜单排序
        comment: "", //
        organizationDepartmentTypeId: "", //部门类型
        address: "", //详细地址
        areaName: "", //区
        chargePersonName: "", //负责人
        cityName: "", //城市
        phone: "", //联系电话
        provinceName: "", //省
      };
    },
    //  弹窗确认保存事件
    diaConfirmBtn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.CalculationRules.parentId == "-1") {
            this.CalculationRules.parentId = "";
          }
          console.log("this.CalculationRules.parentId");
          console.log(this.CalculationRules.parentId);
          if (this.dialogType == "add") {
            // 新建
            this.$API.wtl_addDept(this.CalculationRules).then((res) => {
              this.$message.success(res.data.message || "新建成功");
              this.menushowBOX = false;
              this.resetForm(formName);
              this.getData();
              this.departmentHierarchy(); //左边表格数据
            });
          } else {
            // 修改

            // 去掉多余的参数
            delete this.CalculationRules.organizationDepartmentTypeId;
            delete this.CalculationRules.organizationDepartmentTypeName;
            delete this.CalculationRules.parentName;

            this.$API.wtl_udpateDept(this.CalculationRules).then((res) => {
              this.$message.success(res.data.message || "修改成功");
              this.menushowBOX = false;
              this.resetForm(formName);
              this.getData();
              this.departmentHierarchy(); //左边表格数据
            });
          }
        } else {
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn() {
      this.menushowBOX = false;
    },

    /***
     * ====== 弹窗组件方法 ======
     */

    // 表格选择事件
    handleSelectionChange(e) {
      this.selectTableData = e;
    },

    /**
     * =========================按钮部分的方法=>开始??????????????????????????????????
     */

    //导出操作
    handleCommand_dc(command) {
      if (command == "dc") {
        // 导出
        this.exportBtn();
      } else if (command == "dcmb") {
        // 下载模板
        this.exportTemplateDownload();
      } else if (command == "scmb") {
        // 上传模板
        this.upLoadBtn();
      }
    },

    // ===============================================导出部分=结束======

    /**
     * ******************************计算表格高度**开始*************************
     */
    /***
     * ==============设置表格动态高度==============
     */
    fetTableHeight() {
      // 重置table高度
      this.tabelHeigth = 0;
      // 设置table高度
      let windonHeight =
        document.body.clientHeight || document.documentElement.clientHeight; //页面高度
      let queryHeigth = 40 + 10; //10==margin-top: 10  查询框高度
      let btnListHeight = this.$refs.btnList.offsetHeight; // 按钮列表高度
      if (this.isHaseMore) {
        queryHeigth = this.$refs.queryForm.offsetHeight + 10; //查询框
      }
      let pagsHeigth = 40 + 20; //分页组件高度 20是上下margin
      var otherHeight = queryHeigth + btnListHeight + pagsHeigth + 60; //60是顶部导航 10是
      let tabHeight = Math.floor(windonHeight - otherHeight) || ""; //

      this.$nextTick(() => {
        this.tableHeigth = tabHeight;

        this.leftHeight = windonHeight - 85;
        this.$refs.mytable.doLayout();
      });
    },
    /**
     * ******************************计算表格高度**结束*************************
     */

    // 查询按钮
    queryBtn_ok() {
      this.pageNum = 1;
      this.getData();
    },
    // 重置按钮
    queryBtn_cz() {
      this.queryData = {
        deptName: "",
        parentName: "",
      };
    },

    //分页
    handleSizeChange(val) {
      this.size = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getData();
    },
  },
};
</script>

<style scoped lang="less">
.tabRightBtns{
  justify-content: flex-start;
}
.box {
  width: 100%;
  display: flex;
}
.boxleft {
  // width: 40%;
  width: 370px;
  //   min-width: 390px;
  //   height: 88vh;
  overflow: auto;
  margin-right: 30px;
  // border: 1px solid #d7d7d7;
}
.boxright {
  // width: 70%;
  // flex: 1;
  // height: 500px;
  width: calc(100% - 430px);
}
.tablebut {
  margin-left: 15px;
}
.tableBox {
  height: calc(100% - 260px);
}

.colorStyle {
  color: #f00;
}

.mdTitName {
  height: 24px;
  border: 1px solid #d7d7d7;
  text-align: center;
  min-width: 100px;
}

.queryCriteria {
  .queryItem_one {
    .queryTextarea {
      border: 1px solid #d7d7d7;
    }
  }
  .timeBox {
    border: 1px solid #d7d7d7;
  }
}

.headerbox {
  width: 100%;
  display: flex;
  justify-content: center;
}

.footerbox {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 50px;
}

.newForm {
  margin-left: 80px;
  .queryItem1 {
    width: 60%;
    margin-top: 20px;
    display: flex;
    .inputstyle {
      width: 100%;
      display: flex;
    }
  }
}

.HeadInputbox .item_right .singleinp1 .el-date-editor.el-input,
.HeadInputbox .item_right .singleinp1 .el-date-editor.el-input__inner {
  width: 100%;
}

.frominput ::v-deep {
  .el-input__inner {
    height: 30px;
  }
}

.addressDiv {
  display: flex;
}
</style>
